import { Button, Layout, Tabs } from 'antd'
import { useEffect, useState } from 'react'
import { WeaverLoading } from 'Components'
import Feather from '@sysunite/react-feather'

{ Content } = Layout

EntityDetail = ({ tabs, icon, title, getItem }) -> ({ match }) ->
  { params: { id, action }} = match
  [item, setItem] = useState(undefined)
  [activeKey, setActiveKey] = useState("#{ tabs.findIndex((tab) -> tab.Component?) }")

  useEffect( ->
    (->
      setItem(await getItem(id, action))
    )()
    undefined
  , [id])

  getValue = (val) ->
    if typeof val is 'function'
      val(item)
    else
      val

  getTitle = (title) ->
    getValue(title)

  getDisabled = (disabled) ->
    getValue(disabled)

  <Content style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
    {
      if item?
        tabExtraTitle = (
          <h3 style={{ margin: 0 }}>
            <Feather style={{ marginRight: '6px' }} type={icon} />
            { getTitle(title) }
          </h3>
        )
        <Tabs
          tabBarExtraContent={{ left: tabExtraTitle }}
          activeKey={activeKey}
          onChange={setActiveKey}
          centered
          tabBarStyle={{ padding: '0px 16px', margin: 0 }}
          style={{ flex: 1 }}
        >
          {
            tabs.map(({ title, disabled, Component }, index) ->
              if Component?
                <Tabs.TabPane
                  disabled={getDisabled(disabled)}
                  tab={getTitle(title)}
                  key={index}>
                  <Component onUpdate={setItem} item={item} isActive={index is parseInt(activeKey)} />
                </Tabs.TabPane>
              else
                <Tabs.TabPane tab={getTitle(title)} key={index} disabled />
            )
          }
        </Tabs>
      else
        <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
          <WeaverLoading style={{ width: '10%' }}/>
        </div>
    }
  </Content>

export default EntityDetail
